import Page from '../page.js';

/**
 * Create the action
 */

const { thunk, request, success, error } = Page.index((fetch) =>
    fetch.get('page')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
